let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("3rvO2")]).then(() => parcelRequire('btHFe'));